import { render, staticRenderFns } from "./rdaccountlog-add-or-update.vue?vue&type=template&id=d4c5b696&"
import script from "./rdaccountlog-add-or-update.vue?vue&type=script&lang=js&"
export * from "./rdaccountlog-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports